import { createSlice } from '@reduxjs/toolkit'

export const paypalSlice = createSlice({
  name: 'paypal',
  initialState: {
    buy: '-1',
    email: '',
    itemName: '',
    itemId: '',
    currency: 'USD',
    shipping: '',
    tax: '',
    price: ''
  },
  reducers: {
    setPaypalField(state, action) {
      state[action.payload.key] = action.payload.val
    },
    initializePaypal(state, action) {
      state.buy = '-1'
      state.email = ''
      state.itemName = ''
      state.itemId = ''
      state.currency = 'USD'
      state.shipping = ''
      state.tax = ''
      state.price = ''
    }
  }
})

export const {
  setPaypalField,
  initializePaypal
} = paypalSlice.actions
export default paypalSlice.reducer